import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-38903d22"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "spinner text-center" }
const _hoisted_2 = { class: "text-primary" }
const _hoisted_3 = { class: "font-weight-bold" }

import { withDefaults } from "vue";

interface Props {
  text?: string;
  size?: 1 | 2 | 3 | 4 | 5;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    text: { default: "" },
    size: { default: 2 }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, [
      _createVNode(_component_font_awesome_icon, {
        class: _normalizeClass([`fa-${__props.size}x`, "fa-spin"]),
        icon: "circle-notch"
      }, null, 8, ["class"])
    ]),
    _createElementVNode("p", _hoisted_3, _toDisplayString(__props.text), 1)
  ]))
}
}

})